module.exports = __webpack_public_path__ + "static/media/tz.d02545a1.svg";